<template>
  <div class="body">
    <div v-if="!isEmpty(metadata)" class="artwork-information">
      <img class="back" src="@/assets/icon/back.svg" @click="$router.back()" />
      <div class="artwork-overview">
        <div class="artwork-image">
          <img v-if="metadata.image" :src="metadata.image" />
        </div>
        <div class="info-board">
          <div class="info-title">
            <div>Item name</div>
            <!-- <div>Owner</div> -->
            <div>ID</div>
            <div>Collection</div>
          </div>
          <div class="info">
            <div>{{ metadata.name }}</div>
            <!-- <div>@leslie_alexander</div> -->
            <div class="info-redirect">
              {{ nftId }}
            </div>
            <div class="info-redirect">
              <!--              {{ assetDetail.collectionRef.group }}-->
              {{ collection }}
            </div>
          </div>
        </div>
      </div>
      <div class="artwork-collapse">
        <div class="title">Selling Item</div>
        <div class="selling-method">
          <div class="label" style="margin-right: 8px">Selling Method:</div>
          <custom-dropdown
            class="custom-dropdown"
            :displayList="['Fixed Price', 'Dutch Aution']"
            :valueList="[1, 2]"
            :value="sellingMethod"
            @input="selectSellingMethod"
          />
        </div>
        <div class="starting-expiration-date">
          <div class="date-wrapper">
            <div class="label date-label">Starting Date:</div>
            <v-date-picker
              v-model="startingDate"
              class="date-picker"
              mode="dateTime"
              :timezone="'UTC'"
              :min-date="new Date().valueOf()"
            />
          </div>
          <div class="date-wrapper">
            <div class="label date-label">Expiration Date:</div>
            <v-date-picker
              ref="expirationDate"
              class="date-picker"
              v-model="expirationDate"
              mode="dateTime"
              :timezone="'UTC'"
              :min-date="new Date().valueOf()"
            />
          </div>
          <div class="date-option">
            <filter-option-btn
              :selected="expirationDate - startingDate === shortcut['1week']"
              class="time-option"
              @onClick="handleShortcut(shortcut['1week'])"
            >
              1 week
            </filter-option-btn>
            <filter-option-btn
              :selected="expirationDate - startingDate === shortcut['30days']"
              class="time-option"
              @onClick="handleShortcut(shortcut['30days'])"
            >
              30 days
            </filter-option-btn>
            <filter-option-btn
              :selected="expirationDate - startingDate === shortcut['60days']"
              class="time-option"
              @onClick="handleShortcut(shortcut['60days'])"
            >
              60 days
            </filter-option-btn>
            <filter-option-btn
              :selected="expirationDate - startingDate === shortcut['90days']"
              class="time-option"
              @onClick="handleShortcut(shortcut['90days'])"
            >
              90 days
            </filter-option-btn>
          </div>
        </div>
        <div class="selling-method select-currency">
          <div class="label">Currency:</div>
          <custom-dropdown
            v-model="currency"
            class="custom-dropdown currency"
            :display-list="currenciesDisplay"
            :value-list="currenciesValue"
          />
        </div>

        <div class="available-offer">
          <div class="label">Available to Offer</div>
          <Switches
            v-model="isEnableOffering"
            theme="bulma"
            color="default"
            type-bold="bold"
          />
        </div>
        <!-- <template v-if="sellingMethod == 3">
          <div class="price">
            <div class="label">
              Minium Bid
            </div>
            <input placeholder="Amount"> BUNI
          </div>
          <div class="price">
            <div class="label">
              Reserve Price
            </div>
            <input placeholder="Amount"> BUNI
          </div>
        </template>-->
        <template v-if="sellingMethod == 2">
          <div class="price">
            <div class="label">
              Starting Price
            </div>
            <input v-model="startingPrice" type="number" placeholder="Amount" />
          </div>
          <div class="price">
            <div class="label">
              Ending Price
            </div>
            <input v-model="endingPrice" type="number" placeholder="Amount" />
          </div>
          <div class="price">
            <div class="label">
              Declining Interval
            </div>
            <div>
              Every
              <input
                v-model="decliningInterval"
                placeholder="24"
                type="number"
                step="1"
              />
              hours
            </div>
          </div>
        </template>
        <template v-if="sellingMethod === 1">
          <div class="price">
            <div class="label">Price:</div>
            <input v-model="price" placeholder="Amount" type="number" />
          </div>
        </template>
        <div class="selling-method">
          <div class="label">Tax:</div>
          <div>10%</div>
        </div>
        <div class="selling-method" v-if="sellingMethod === 1">
          <div class="label">Final Price:</div>
          <div>{{ finalPrice }}</div>
        </div>
        <div v-if="errorMsg" class="error">
          {{ errorMsg }}
        </div>
        <div class="btn-wrapper">
          <primary-button
            class="btn-listing"
            :is-disable="isDisableListing"
            @onClick="onListingNFT"
          >
            <template v-if="isListing">
              <b-icon icon="arrow-clockwise" animation="spin" font-scale="2" />
            </template>
            <template v-else> Listing </template>
          </primary-button>
          <filter-option-btn
            class="btn-cancel"
            @onClick="$router.push({ name: 'my-collection' })"
          >
            Cancel
          </filter-option-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropdown from '@/components/BaseComponents/CustomDropdown.vue';
import FilterOptionBtn from '@/components/BaseComponents/FilterOptionBtn.vue';
import PrimaryButton from '@/components/BaseComponents/PrimaryButton.vue';
import Switches from 'vue-switches';
import { convertDecToWei } from '@/helpers';
import { getMetadataFromURIs } from '@/helpers/utils';
import provider from '@/helpers/provider';
import abi from '../../../abi';
import { Contract } from '@ethersproject/contracts';
import _ from 'lodash';
import config from '@/config';
import { addMarketListing, addDutchAuctionListing } from '@/helpers/utils';
import { handleTransactionError } from '@/helpers';
import moment from 'moment';
import { ONE_HOUR_TO_MILLISECONDS, SELLING_METHOD } from '@/constans';
const DATE_SHORT_CUT = {
  '1week': 604800000,
  '30days': 2592000000,
  '60days': 5184000000,
  '90days': 7776000000
};

export default {
  components: {
    CustomDropdown,
    FilterOptionBtn,
    PrimaryButton,
    Switches
  },
  data() {
    return {
      sellingMethod: 1,
      metadata: {},
      nftContract: '',
      nftId: '',
      sellerAddress: '',
      isArtWork: false,
      startingPrice: '',
      endingPrice: '',
      price: '',
      decliningInterval: '',
      maxPrice: 1000000,
      startingDate: new Date().valueOf(),
      expirationDate: new Date().valueOf() + DATE_SHORT_CUT['90days'],
      dateShortcut: DATE_SHORT_CUT['90days'],
      isListing: false,
      currenciesDisplay: config.supportCurrencies.map(
        currency => currency.symbol
      ),
      currenciesValue: config.supportCurrencies.map(
        currency => currency.address
      ),
      currency: config.defaultCurrency.address,
      collection: '',
      shortcut: DATE_SHORT_CUT,
      isEnableOffering: false
    };
  },
  computed: {
    myAddress() {
      return this.$store.state.auth.address;
    },
    isInvalidDecliningInterval() {
      if (this.sellingMethod === 2) {
        return !(
          this.decliningInterval >= 0.0 &&
          Math.floor(this.decliningInterval) === this.decliningInterval &&
          this.decliningInterval !== Infinity
        );
      }
      return false;
    },
    isDisableListing() {
      return (
        (this.sellingMethod === 1 && !this.isValidPrice(this.price)) ||
        (this.sellingMethod === 2 &&
          (!this.isValidPrice(this.startingPrice) ||
            !this.isValidPrice(this.endingPrice) ||
            Number(this.startingPrice) < Number(this.endingPrice))) ||
        this.expirationDate <= this.startingDate ||
        !this.currency ||
        (this.sellingMethod === 2 &&
          !this.isNaturalNumber(parseFloat(this.decliningInterval))) ||
        (this.sellingMethod === SELLING_METHOD.dutchAuction &&
          !this.isEnoughtOneHour) ||
        !this.startingDate
      );
    },
    isEnoughtOneHour() {
      return (
        this.expirationDate - this.startingDate >= ONE_HOUR_TO_MILLISECONDS
      );
    },
    errorMsg() {
      const currentDate = new Date().valueOf();
      if (this.startingDate < currentDate || this.expirationDate < currentDate)
        return 'Start time and expiration time must be greater than current time';
      if (
        (this.sellingMethod === 1 && Number(this.price) <= 0) ||
        (this.sellingMethod === 2 &&
          (Number(this.startingPrice <= 0) || Number(this.endingPrice <= 0)))
      )
        return 'Price must be greater than 0';
      if (
        (this.sellingMethod === 1 && Number(this.price) > this.maxPrice) ||
        (this.sellingMethod === 2 &&
          (Number(this.startingPrice > this.maxPrice) ||
            Number(this.endingPrice > this.maxPrice)))
      )
        return 'Price must be smaller than 1,000,000';
      if (this.expirationDate <= this.startingDate)
        return 'Expiration Date must be greater than Starting Date';
      if (!this.currency) return 'Currency must be selected';
      if (
        this.sellingMethod === 2 &&
        !this.isNaturalNumber(parseFloat(this.decliningInterval))
      )
        return 'Declining Interval must be an natural number';
      if (
        this.sellingMethod === 2 &&
        Number(this.startingPrice) < Number(this.endingPrice)
      )
        return 'Ending Price must be equal or smaller than Starting Price';
      if (
        this.sellingMethod === SELLING_METHOD.dutchAuction &&
        !this.isEnoughtOneHour
      )
        return 'Expiration Date must be at least one hour longer than Starting Date';
      if (!this.startingDate) return 'Please select a Starting Date';
      return '';
    },
    finalPrice() {
      return this.price === 0
        ? 0
        : +(Number(this.price) + Number(this.price) * 0.1).toFixed(4);
    }
  },
  watch: {
    startingDate() {
      this.expirationDate =
        new Date(this.startingDate).valueOf() + this.dateShortcut;
    }
  },
  async mounted() {
    const { nftContract, nftId } = this.$route.params;
    this.isArtWork = nftContract === config.addresses.artworkNftAddress;
    this.nftContract = nftContract;
    this.nftId = nftId;
    this.collection = this.getNFTCollection(this.nftContract.toLowerCase());
    const tokenURI = await this.getTokenURI(nftContract, nftId);
    const [metadata] = await getMetadataFromURIs([tokenURI]);
    this.metadata = metadata;
  },
  methods: {
    isNaturalNumber(number) {
      return number >= 1 && Number.isInteger(number);
    },
    isValidPrice(price) {
      return Number(price) > 0 && Number(price <= this.maxPrice);
    },
    selectSellingMethod(value) {
      this.sellingMethod = value;
    },
    convertDecToWei,
    handleTransactionError,
    getNFTCollection(nftContract) {
      if (nftContract === config.addresses.artworkNftAddress.toLowerCase())
        return 'Artwork';
      return (
        config.projects.bunicornGame.collections.find(
          nft => nft.nftContract.toLowerCase() === nftContract
        ).nftName || 'N/A'
      );
    },
    async handleShortcut(value) {
      if (value === this.dateShortcut) this.dateShortcut = 0;
      else this.dateShortcut = value;
      const expirationDate =
        new Date(this.startingDate).valueOf() + this.dateShortcut;
      this.expirationDate = expirationDate;
      if (this.$refs && this.$refs.expirationDate) {
        this.$refs.expirationDate.move(
          moment(this.expirationDate).format('YYYY-MM-DD')
        );
      }
    },
    async onListingNFT() {
      if (this.isListing) return;
      this.isListing = true;
      try {
        let tx;
        if (this.sellingMethod === 1) {
          tx = await addMarketListing(
            this.nftContract,
            this.nftId,
            this.convertDecToWei(this.price),
            this.currency,
            Math.floor(this.startingDate / 1000),
            Math.floor(this.expirationDate / 1000),
            this.isArtWork,
            this.isEnableOffering
          );
        }
        if (this.sellingMethod === 2) {
          tx = await addDutchAuctionListing(
            this.nftContract,
            this.nftId,
            this.convertDecToWei(this.startingPrice),
            this.convertDecToWei(this.endingPrice),
            this.decliningInterval * 3600,
            this.currency,
            Math.floor(this.startingDate / 1000),
            Math.floor(this.expirationDate / 1000),
            this.isEnableOffering
          );
        }

        if (tx.transactionHash) {
          this.$dialog.notify.success("You've listed NFT successfully!");
          this.$router.push('/my-collection/on-market');
        } else {
          this.$dialog.notify.error('An error has occurred. Please try again!');
        }
      } catch (error) {
        this.isListing = false;
        const message = this.handleTransactionError(error);
        this.$dialog.notify.error(message);
      }
      this.isListing = false;
    },
    isEmpty(data) {
      return _.isEmpty(data);
    },
    getTokenURI(nftContractAddress, nftId) {
      const nftContract = new Contract(
        nftContractAddress,
        abi['NFT721'],
        provider
      );
      return nftContract.tokenURI(nftId);
    },
    getMarketplaceContractAddress(nftContractAddress) {
      const projects = config.projects;

      let marketplaceAddress = config.addresses.marketplaceAddress;
      _.forEach(projects, project => {
        _.forEach(project.collections, collection => {
          if (
            collection.nftContract.toLowerCase() ===
              nftContractAddress.toLowerCase() &&
            project.marketplaceAddress
          ) {
            marketplaceAddress = project.marketplaceAddress;
          }
        });
      });
      return marketplaceAddress;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';
.error {
  color: red;
  margin-top: 20px;
}
.body {
  margin: 40px 40px;
  .artwork-information {
    display: flex;
    font-family: Inter;
    flex-wrap: wrap;
    position: relative;
    .back {
      position: absolute;
      top: -30px;
      left: 0;
      cursor: pointer;
      width: 25px;
      height: 25px;
      object-fit: contain;
    }
    .artwork-overview {
      width: 242px;
      .artwork-image {
        width: 242px;
        height: 300px;
        position: relative;
        ::v-deep .slick-next:before,
        .slick-prev:before {
          content: '';
        }
        .custom-arrow {
          width: 36px;
          height: 36px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .slick-prev {
          left: 0;
        }
        .slick-next {
          right: 0;
        }
        .like-button {
          position: absolute;
          top: 10px;
          right: 10px;
          background-color: #ffffff;
          border-radius: 50%;
          padding: 8px;
        }
      }
      .info-board {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        line-height: 24px;
        .info-title {
          color: #828c9f;
        }
        .info {
          text-align: right;
          font-weight: 500;
          color: #203a54;
          // .info-redirect {
          //   color: #00a3fe;
          // }
        }
      }
    }
    .artwork-collapse {
      margin-left: 30px;
      flex-grow: 1;
      .title {
        color: #18324c;
        font-size: 26px;
        font-family: Inter-Bold;
      }
      .label {
        color: #18324c;
        font-size: 20px;
        font-family: Inter-Medium;
        white-space: nowrap;
        width: 200px;
        &.date-label {
          width: 180px;
        }
      }
      .available-offer {
        .vue-switcher {
          margin-bottom: 0;
          margin-top: 1rem;
        }
        ::v-deep .vue-switcher-theme--bulma.vue-switcher-color--default div {
          background-color: #5b6ef5;
        }
        ::v-deep
          .vue-switcher-theme--bulma.vue-switcher-color--default.vue-switcher--unchecked
          div {
          background-color: #e8e8e8;
        }
      }

      .selling-method,
      .available-offer,
      .price,
      .btn-wrapper {
        &.select-currency {
          margin-top: 30px;
        }
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 20px;
        .currency {
          width: 180px;
          ::v-deep .custom-dropdown {
            height: 34px;
          }
        }
      }
      .btn-wrapper {
        .btn-listing,
        .btn-cancel {
          width: 150px;
          height: 48px;
          margin-right: 12px;
        }
      }
      .price {
        .label {
          width: 200px;
          white-space: nowrap;
        }
        input {
          color: #798392;
          font-family: Inter;
          border: 1px solid #e3e6e9;
          box-sizing: border-box;
          border-radius: 6px;
          padding: 4px 10px;
          width: 180px;
        }
        color: #18324c;
        font-size: 16px;
        font-family: Inter;
      }
      .starting-expiration-date {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        // flex-wrap: wrap;
        .date-wrapper,
        .date-option {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          margin-right: 20px;
          .label {
            margin-bottom: 20px;
          }
          .date-picker {
            margin: auto;
          }
          .time-option {
            margin: 6px 0;
            width: 102px;
          }
        }
        .date-wrapper {
          width: 40%;
        }
        .date-option {
          width: 20%;
        }
      }
    }
  }
}

@media screen and (max-width: $breakpoint-desktop) {
  .body {
    .artwork-information {
      .artwork-overview {
        width: 100%;
        align-items: center;
        .artwork-image {
          margin: auto;
        }
      }
      .artwork-collapse {
        margin-top: 60px;
        // .starting-expiration-date {
        //   .date-option {
        //     flex-direction: row;
        //     justify-content: space-evenly;
        //     .time-option {
        //       min-width: fit-content;
        //     }
        //   }
        // }
      }
    }
  }
}
@media screen and (max-width: $breakpoint-mobile) {
  .body {
    margin: 0;
    padding: 10px;
    .artwork-information {
      .artwork-collapse {
        margin-top: 30px;
        margin-left: 0;
        .label {
          white-space: nowrap;
          font-size: 18px;
        }
        .starting-expiration-date {
          flex-wrap: wrap;
          .date-wrapper,
          .date-option {
            width: 100%;
            margin: 12px 0;
            .time-option {
              margin: 4px;
            }
          }
          .date-option {
            flex-direction: row;
            flex-wrap: wrap;
          }
        }
        .selling-method,
        .available-offer,
        .price {
          .amount {
            width: 180px;
          }
          margin-top: 20px;
        }
        .price {
          .label {
            margin-bottom: 12px;
          }
        }
        .btn-wrapper {
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>
